import { createReducer, on } from '@ngrx/store';

import { OrbiFeatureActions } from './orbi-feature.actions';
import * as AuthActions from '../auth/auth.actions';

export const orbiFeatureKey = 'orbiFeature';

export interface OrbiFeatureState {
  /**
   * Whether the web AI agent (entry point, chat panel, gateway calls) is
   * enabled. Defaults to FALSE so an unevaluated / unavailable flag keeps the
   * feature OFF (fail-closed for an unreleased experience).
   */
  orbiAgentEnabled: boolean;
}

export const initialOrbiFeatureState: OrbiFeatureState = {
  orbiAgentEnabled: false,
};

export const orbiFeatureReducer = createReducer(
  initialOrbiFeatureState,
  on(OrbiFeatureActions.setOrbiAgentEnabled, (state, { enabled }) => ({
    ...state,
    orbiAgentEnabled: enabled,
  })),
  // Clear the flag on logout so a new session re-evaluates from scratch. Keyed on
  // `logOut` as well as `logOutSuccess` (QA 08/21): `logOut` is the first action of
  // a sign-out, so the agent goes with the session rather than with the logout
  // API's response — and a `logOutFailure` still redirects the patient away, which
  // would otherwise leave the flag armed.
  on(AuthActions.logOut, AuthActions.logOutSuccess, () => ({
    ...initialOrbiFeatureState,
  }))
);
